// removed by extract-text-webpack-plugin
module.exports = {"component":"_-AUiazvigZQ3uKRCWJkBL","background":"Nx6f4Wn5ybsrw_BM_NCWl","list":"BhcS6yunVPdpzVERkXLwY"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/ImgsWallOfDetail/ImgsWallOfDetail.scss
 ** module id = 984
 ** module chunks = 0
 **/